import React from 'react';
import './header.css';
import logo from '../header/header-logo.png'; // Make sure the image is in the correct path

const Header = () => {
  return (
    <header className="header">
      <div className="header__logo">
        <img src={logo} alt="Header Logo" />
      </div>
    </header>
  );
};

export default Header;
